<template>
    <div class="row justify-content-center">
        <input type="hidden" name="lat" id="lat">
        <input type="hidden" name="lon" id="lon">
        <input type="hidden" name="endereco" id="endereco">
        <div class="col-md-2">
            <InputIconGroup @change="searchCep()" typeInput="text" idInput="cep" iconInput="fa-info"
                            labelInput="CEP" :inputMask="['########']">
            <a href="http://www.buscacep.correios.com.br/sistemas/buscacep/buscaCepEndereco.cfm"
                target="_blank">Consulte o CEP por endereço</a>
            </InputIconGroup>
        </div>
        <div class="col-md-3">
            <InputIconGroup typeInput="text" idInput="logradouro" iconInput="fa-info"
                            labelInput="" :inputDisabled="disabled">
                Logradouro
            </InputIconGroup>
        </div>
        <div class="col-md-2">
            <InputIconGroup typeInput="text" idInput="bairro" iconInput="fa-info"
                            labelInput="" :inputDisabled="disabled">
                Bairro
            </InputIconGroup>
        </div>
        <div class="col-md-2">
            <InputIconGroup typeInput="text" idInput="cidade" iconInput="fa-info"
                            labelInput="" inputDisabled="disabled">
                Cidade
            </InputIconGroup>
        </div>
        <div class="col-md-1">
            <InputIconGroup typeInput="text" idInput="uf" iconInput="fa-info" labelInput=""
                            inputDisabled="disabled">
                UF
            </InputIconGroup>
        </div>
        <div class="col-md-2">
            <InputIconGroup @change="searchCep()" typeInput="text" idInput="numero" iconInput="fa-info"
                            labelInput="Número">
                &nbsp;
            </InputIconGroup>
        </div>
        <div class="row justify-content-center text-center">
            <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
                <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                    <component id="load" v-show="mapLoad"
                        :animation-duration="1000"
                        :is="'LoopingRhombusesSpinner'"
                        :color="'#4AE387'"
                        :size="500"
                    >
                    </component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import InputIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/InputIconGroup'
import GoogleMapController from './GoogleMapController'
import urlApi from '../../router/urlApi'
import * as spinners from 'epic-spinners'

export default {
  name: 'App',
  components: {
    InputIconGroup,
    ...spinners,
  },
  props: {},
  data () {
    return {
      mapLoad: false,
      disabled: 'disabled',
    }
  },
  mounted () {
    GoogleMapController.getMap()
  },
  methods: {
    searchCep () {
      let self = this
      var cep = document.getElementById('cep').value
      var numero = document.getElementById('numero').value

      if (cep && numero) {
        self.mapLoad = true
        self.$http.get(urlApi + '/enderecos/' + cep).then((response) => {

          if (response.data.sucesso) {
            response.data.dados.numero = numero
            if (response.status === 200 && response.data.sucesso) {
	      if (!(typeof response.data.dados.logradouro === 'object')) {
                document.getElementById('logradouro').value = response.data.dados.logradouro
	      } else {
                document.getElementById('logradouro').value = 'INDEFINIDO'
                self.disabled = null
	      }

	      if (!(typeof response.data.dados.bairro === 'object')) {
                document.getElementById('bairro').value = response.data.dados.bairro
              } else {
                document.getElementById('bairro').value = 'INDEFINIDO'
                self.disabled = null
              }

              var prefix = response.data.dados;
              var endereco = prefix.logradouro+" "+prefix.numero+", "+prefix.bairro+", "+prefix.municipio+"-"+prefix.uf;
              document.getElementById('endereco').value = endereco

              console.log(endereco);

              document.getElementById('cidade').value = response.data.dados.municipio
              document.getElementById('uf').value = response.data.dados.uf
              GoogleMapController.panToLocation(response.data.dados, function (res) { self.mapLoad = res })
            } else {
              document.getElementById('logradouro').value = ''
              document.getElementById('cidade').value = ''
              document.getElementById('uf').value = ''
              document.getElementById('bairro').value = ''
            }
          } else {
            self.mapLoad = false
            this.$toasted.show(response.data.mensagem, {
              icon: 'fa-times',
              position: 'top-right',
              duration: 5000,
              fullWidth: false
            })
          }
        })
      }
    },
  }
}
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
}
</style>
